import { useState } from "react";

export function useMenusPorEventoUI() {
    const [query, setQuery] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [estado, setEstado] = useState("todos");
    const [sortBy, setSortBy] = useState("inicio");

    const [openEvent, setOpenEvent] = useState(new Set());
    const [openMenus, setOpenMenus] = useState({}); // { [eventoId]: Set<menuIndex> }

    const toggleEvent = (id) => {
        setOpenEvent((prev) => {
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    };

    const toggleMenu = (eventoId, idx) => {
        setOpenMenus((prev) => {
            const set = new Set(prev[eventoId] || []);
            set.has(idx) ? set.delete(idx) : set.add(idx);
            return { ...prev, [eventoId]: set };
        });
    };

    const isEventOpen = (id) => openEvent.has(id);
    const isMenuOpen = (eventoId, idx) => openMenus[eventoId]?.has(idx);

    return {
        query, setQuery,
        dateFrom, setDateFrom,
        dateTo, setDateTo,
        estado, setEstado,
        sortBy, setSortBy,
        toggleEvent, isEventOpen,
        toggleMenu, isMenuOpen,
    };
}
